import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import FlightsSearchForm from './FlightsSearchForm'
import withFlightState from './withFlightState'
import withValidation from './withValidation'
import validateFlightsSchema from './validateFlightsSchema'
import { init } from '@pcln/home-components'

const StatefulForm = withFlightState(withValidation(FlightsSearchForm))

function FlightsSearchContainer (props) {
  useEffect(() => {
    init()
  }, [])

  return <StatefulForm {...props} />
}

FlightsSearchContainer.propTypes = {
  mapper: PropTypes.func,
  errors: PropTypes.object
}

FlightsSearchContainer.defaultProps = {
  mapper: validateFlightsSchema,
  errors: {
    flights: [{}]
  }
}

export default FlightsSearchContainer
